import { AspectRatio, Box, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const HowToUse = () => {
  return (
    <VStack mt={8} w="100%">
      <Text
        textTransform="uppercase"
        textStyle="docMainTitle"
        textAlign="center"
      >
        How To Use
      </Text>
      <VStack mt={6} w="100%">
        <AspectRatio
          mt={5}
          w={{
            base: '90%',
            sm: '480px',
            md: '600px'
          }}
          ratio={600 / 296}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/how-to-use-1711000653167.png"
            alt="how to use"
            fill
          />
        </AspectRatio>
      </VStack>
    </VStack>
  )
}
export default HowToUse
